import { render, staticRenderFns } from "./BaseTableAction.vue?vue&type=template&id=40f51b59&scoped=true"
import script from "./BaseTableAction.vue?vue&type=script&lang=js"
export * from "./BaseTableAction.vue?vue&type=script&lang=js"
import style0 from "./BaseTableAction.vue?vue&type=style&index=0&id=40f51b59&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f51b59",
  null
  
)

export default component.exports